/** Sign-in, password reset and invite acceptance (K1). */
export const authCopy = {
  username: 'Username',
  password: 'Password',
  confirmPassword: 'Confirm password',
  passwordTooShort: 'Use at least 8 characters.',
  passwordMismatch: 'Enter the same password in both fields.',
  backToSignIn: 'Back to sign in',
  login: {
    submit: 'Sign in',
    forgotPassword: 'Forgot password?',
    wrongCredentials:
      'Username or password is incorrect — check both and try again.',
    failed: 'Failed to sign in — try again.',
  },
  forgot: {
    heading: 'Reset your password',
    email: 'Email address',
    submit: 'Send link',
    sent: 'If an account exists for that email, a reset link is on the way.',
    failed: 'Failed to send the reset link — try again.',
  },
  reset: {
    heading: 'Set a new password',
    newPassword: 'New password',
    submit: 'Reset password',
    done: 'Password reset',
    failed: 'Failed to reset password — try again.',
    missingToken: 'This reset link is incomplete — request a new one.',
    invalidToken:
      'This reset link is invalid or has expired — request a new one.',
    incomplete:
      'Failed to reset password — open the link from your email and try again.',
    requestNewLink: 'Request a new reset link',
  },
  invite: {
    heading: 'Create your account',
    submit: 'Create account',
    failed: 'Failed to create account — try again.',
    invalid:
      'This invite link is invalid or has already been used — ask for a new invite.',
    usernameTaken: 'Username already taken — choose another.',
    incomplete: 'Enter a username and password.',
  },
} as const
